import Immutable from 'seamless-immutable';
import * as SearchActions from '../actions/search.coupon.actions';
export var INITIAL_STATE = Immutable({
  couponSearchModel: null
});
export default function SearchCouponsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SearchActions.SET_COUPON_SEARCH_MODEL:
      return state.set('couponSearchModel', payload);
    case SearchActions.RESET_SEARCH_COUPON_MODEL_RECOVERABLE:
      return INITIAL_STATE;
    default:
      return state;
  }
}